/**
 * Impersonation gate — entry point for "log in as client" links issued to
 * Ranger Station admins. Stores the impersonation JWT and drops the admin
 * into the client's dashboard.
 */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function ImpersonatePage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Missing impersonation token.');
      return;
    }
    localStorage.setItem('auth_token', token);
    localStorage.setItem('impersonating_token', 'true');
    localStorage.removeItem('admin_original_token');
    window.location.href = '/';
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">{error ?? 'Logging in as client…'}</p>
    </div>
  );
}
